// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uMmy","rootNoMargin":"styles_rootNoMargin__1GOod"};